
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("分销用户列表", ["分销管理;distributions", route.params.distribution_id.toString()])
    });

    const store = useStore();
    const router = useRouter();
    const route = useRoute()
    const tableData = ref([]);

    const formData = ref({
      name: "",
      mobile: "",
    });

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    });

    let date = new Date()
    let from = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
    let to = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)

    const water_duration = ref([
      from,
      to,
    ])

    const query = () => {
      store
        .dispatch(Actions.GET_DISTRIBUTION_USERS, { 
          distribution_id: route.params.distribution_id, 
          ...formData.value, 
          ...page.value,
          from: `${water_duration.value[0].toLocaleDateString()} ${water_duration.value[0].getHours()}:${water_duration.value[0].getMinutes()}:${water_duration.value[0].getSeconds()}`,
          to: `${water_duration.value[1].toLocaleDateString()} ${water_duration.value[1].getHours()}:${water_duration.value[1].getMinutes()}:${water_duration.value[1].getSeconds()}` 
        })
        .then(() => {
          tableData.value = store.getters.currentDistributionUsers;
          page.value.totalResult = store.getters.currentDistributionUserCount;
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        });
    };

    query();

    const submitEvent = () => {
      query();
    };

    const onPageChange = (e) => {
      page.value.currentPage = e.currentPage;
      query();
    };

    const onReset = () => {
      formData.value = {
        name: "",
        mobile: "",
      };
    };

    const onDelete = (id) => {
      Swal.fire({
        title: '确认删除？',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: '确认',
        // denyButtonText: '取消',
        cancelButtonText: '取消'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          store
            .dispatch(Actions.DELETE_DISTRIBUTION_USER, {distribution_id: route.params.distribution_id.toString(), id: id})
            .then(() => {
              query()
            })
            .catch(() => {
              // const [error] = Object.keys(store.getters.getErrors);
              // Swal.fire({
              //   text: store.getters.getErrors[error],
              //   icon: "error",
              //   buttonsStyling: false,
              //   confirmButtonText: "Try again!",
              //   customClass: {
              //     confirmButton: "btn fw-bold btn-light-danger",
              //   },
              // });
            })
          // Swal.fire('Saved!', '', 'success')
        // } else if (result.isDenied) {
          // Swal.fire('Changes are not saved', '', 'info')
        }
      })
    }

    return {
      tableData,
      formData,
      submitEvent,
      page,
      onPageChange,
      onReset,
      water_duration,
      onDelete
    };
  },
});
